import "core-js/modules/es.regexp.exec.js";
import React, { lazy, Suspense } from 'react';
import { Show, TrackingFunnelProvider, ErrorNamespaceProvider, BlockingErrorBoundary } from '@edreamsodigeo/frontend-core';
const ModifyLCFunnel = /*#__PURE__*/lazy(() => import(/* webpackChunkName: "modifylcfunnel" */
/* webpackPrefetch: true */
'./ModificationLCFunnel'));
const ModifyFunnel = /*#__PURE__*/lazy(() => import(/* webpackChunkName: "modifyfunnel" */
/* webpackPrefetch: true */
'./ModificationFunnel'));
const modificationRegex = /\/travel\/modifications\//;
export function ModificationFunnel() {
  return /*#__PURE__*/React.createElement(ErrorNamespaceProvider, {
    namespace: "shell_funnel_modifications"
  }, /*#__PURE__*/React.createElement(BlockingErrorBoundary, {
    name: "funnel_modification"
  }, /*#__PURE__*/React.createElement(Show, {
    when: modificationRegex.test(window.location.href)
  }, /*#__PURE__*/React.createElement(TrackingFunnelProvider, {
    funnel: "modification"
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(ModifyFunnel, null))))));
}
export function ModificationLCFunnel() {
  return /*#__PURE__*/React.createElement(ErrorNamespaceProvider, {
    namespace: "shell_funnel_modifications_lc"
  }, /*#__PURE__*/React.createElement(BlockingErrorBoundary, {
    name: "funnel_modification_lc"
  }, /*#__PURE__*/React.createElement(Show, {
    when: modificationRegex.test(window.location.href)
  }, /*#__PURE__*/React.createElement(TrackingFunnelProvider, {
    funnel: "modification_lc"
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(ModifyLCFunnel, null))))));
}